import React, {Component} from 'react';
import {Input, Button, Card, Row, Col, Form, Divider, Checkbox} from 'antd';

const {Item: FormItem} = Form;

class Branch extends Component {
    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 18,
                    offset: 4,
                },
            },
        };



        const { getFieldDecorator } = this.props.form;
        const {onSubmit, branch, form} = this.props;
        const getDefaultVal = (key) => {
            return (branch && branch[key]) || '';
        };
        const handleSubmit = (e) => {
            e.preventDefault();
            return form.validateFieldsAndScroll((err, values) => {
                if (err) {
                    return;
                }
                return onSubmit(values);
            });
        };
        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>{branch && !branch.draft ? 'Edit ': 'New '}Branch Details</span>
            </div>
        );

        const onCancel = (e) => {
            return this.props.onCancel(e);
        };

        return (
            <Card title={title()} bordered={false}>
                <Row style={{ marginTop: '10px' }} gutter={16}>
                    <Col md={{span: 18, offset: 3}}>
                        <Form onSubmit={handleSubmit}>
                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label={(
                                    <span>Branch Name</span>
                                )}
                            >
                                {getFieldDecorator('branch_name', {
                                    initialValue: getDefaultVal('branch_name'),
                                    rules: [{ required: true, message: 'Please input your branch name!', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Address Line 1"
                            >
                                {getFieldDecorator('address_line_1', {
                                    initialValue: getDefaultVal('address_line_1'),
                                    rules: [{ required: true, message: 'Please input your address line 1', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Address Line 2"
                            >
                                {getFieldDecorator('address_line_2', {
                                    initialValue: getDefaultVal('address_line_2'),
                                    rules: [{ required: true, message: 'Please input your address line 2', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Address Line 3"
                            >
                                {getFieldDecorator('address_line_3', {
                                    initialValue: getDefaultVal('address_line_3'),
                                    rules: [{ required: false, message: 'Please input your address line 3', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Post Code"
                            >
                                {getFieldDecorator('post_code', {
                                    initialValue: getDefaultVal('post_code'),
                                    normalize: value => {
                                        if (!value) return "";
                                        return value.replace(/[ ]+/g, '')
                                            .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2")
                                            .toUpperCase();
                                    },
                                    rules: [
                                        { pattern: '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}', message: 'Invalid post code', transform: value => {
                                            return value.replace(/[ ]+/g, '')
                                                .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2");
                                        }},
                                        { required: true, message: 'Please input your post code', whitespace: true }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="Main Office"
                            >
                                {getFieldDecorator('main_office', {
                                    initialValue: !!getDefaultVal('main_office'),
                                    valuePropName: 'checked'
                                })(
                                    <Checkbox/>
                                )}
                            </FormItem>

                            <Divider />

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Phone Number"
                            >
                                {getFieldDecorator('phone_number', {
                                    initialValue: getDefaultVal('phone_number'),
                                    rules: [
                                        { pattern: /\d{11}$/, message: 'Invalid phone number' },
                                        { required: true, message: 'Please input your phone number!', whitespace: true }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="E-mail"
                            >
                                {getFieldDecorator('email', {
                                    initialValue: getDefaultVal('email'),
                                    rules: [{
                                        type: 'email', message: 'The input is not valid E-mail!',
                                    }, {
                                        required: true, message: 'Please input your E-mail!', whitespace: true,
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Main Contact Name"
                            >
                                {getFieldDecorator('contact_name', {
                                    initialValue: getDefaultVal('contact_name'),
                                    rules: [{ required: true, message: 'Please input your main contact name', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem {...tailFormItemLayout}>
                                <Button size='large' onClick={onCancel} style={{marginRight: 10}}>Cancel</Button>
                                <Button size='large' type="primary" htmlType="submit">Submit</Button>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </Card>
        );
    }
}

const WrappedForm = Form.create()(Branch);
export default WrappedForm;


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/Branch.js